import { HttpClient, HttpHeaders } from "@angular/common/http"
import { Injectable } from "@angular/core"
import { CookiesService } from "./cookies.service"

declare var window: any

@Injectable()
export class LmApiService {
    public adminOnlyQueryParamCookies = ["pmc"]
    public optionalQueryParamCookies = ["user_content_permission", "logged_in"]
    public apiKey = window.PBSLM.NG.API_KEY
    private _adminDisplay = window.PBSLM.NG.ADMIN_DISPLAY
    private _isSU = window.PBSLM.NG.IS_SU

    constructor(
        private http: HttpClient,
        private cookieService: CookiesService
    ) {}

    private userHasAdminDisplay() {
        // This is duplicate functionality of UserService.hasAdminDisplay() to avoiding circular dependency
        return this._adminDisplay || this._isSU
    }

    public makeAPIUrl(url) {
        if (url.startsWith("http://") || url.startsWith("https://")) return url

        if (url.startsWith("/")) url = url.slice(1)

        return window.PBSLM.NATIONAL_SITE_URL + url
    }

    public get(url: string, params: any = {}) {
        this.setHeaders(params)
        return this.http.get(url, params)
    }

    public post(url: string, data, params: any = {}): any {
        this.setHeaders(params)
        return this.http.post(url, data, params)
    }

    public put(url: string, data, params: any = {}) {
        this.setHeaders(params)
        return this.http.put(url, data, params)
    }

    public delete(url: string, params: any = {}) {
        this.setHeaders(params)
        return this.http.delete(url, params)
    }

    public getWithCookiesInParams(
        url: string,
        cookiesToSend: string[] = [],
        params: any = {}
    ) {
        url = this.makeAPIUrl(url)
        cookiesToSend = this.addAdminCookies(cookiesToSend)
        url = this.sendCookiesAsQueryParams(url, cookiesToSend)
        this.setHeaders(params)
        return this.http.get(url, params)
    }

    public getWithCookiesInParamsAll(url: string, params: any = {}) {
        let cookiesToSend = this.optionalQueryParamCookies

        cookiesToSend = this.addAdminCookies(cookiesToSend)
        url = this.makeAPIUrl(url)
        url = this.sendCookiesAsQueryParams(url, cookiesToSend)
        this.setHeaders(params)
        return this.http.get(url, params)
    }

    // if params contain headers they should be plain object because get converts them to HttpHeaders
    private setHeaders(params) {
        const headAuth = {
            Authorization: "Bearer " + this.apiKey,
        }
        if (params.headers) {
            params.headers = { ...headAuth, ...params.headers }
        } else {
            params.headers = headAuth
        }
        params.headers = new HttpHeaders(params.headers)
    }

    private addAdminCookies(cookiesToSend) {
        if (this.userHasAdminDisplay()) {
            cookiesToSend = cookiesToSend.concat(
                this.adminOnlyQueryParamCookies
            )
        }
        return cookiesToSend
    }
    private sendCookiesAsQueryParams(url, cookies: string[]) {
        if (url.indexOf("?") == -1) {
            url += "?"
        }

        cookies.forEach((cookie_name) => {
            let cookie = this.cookieService.getCookie(cookie_name)
            if (cookie && cookie.value) {
                if (!url.endsWith("?")) {
                    url += "&"
                }
                url += "cookie:" + cookie.key + "=" + cookie.value
            }
        })

        if (url.endsWith("?")) {
            // no actual cookie was added
            url = url.slice(0, -1)
        }

        return url
    }
}
